<template>
	<modal ref="modal" title="Clone Company Form" :close_on_focus="!cloning" :no_overflow="true">
		<div class="form-group row">
			<div class="col-12">
				<label>Company</label>
			</div>
			<div class="col-12">
				<select v-bind:disabled="cloning" class="form-control border" name="company" v-model="selected_company">
					<option :value="null" selected hidden>--- Select a Company ---</option>
					<option v-for="company in companies" :value="company.id">{{company.name}}</option>
				</select>
			</div>
		</div>
		<div class="form-group row">
			<div class="col-12">
				<label>Form</label>
			</div>
			<div class="col-12">
				<select v-bind:disabled="cloning" class="form-control border" name="company" v-model="selected_form">
					<option :value="null" selected hidden>--- Select a Form ---</option>
					<option v-if="!forms.length" :value="false" disabled>(No custom forms)</option>
					<option v-for="form in forms" :value="form.id">{{form.name}}</option>
				</select>
			</div>
		</div>
		<div class="form-group row">
			<div v-if="loading" class="col-12">
				<loader></loader>
			</div>
			<div v-else class="col-12 text-right">
				<button class="btn btn-secondary" v-on:click="cancel()">Cancel</button>
				<button class="btn btn-primary ml-2" v-on:click="clone()">Clone</button>
			</div>
		</div>
	</modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	import Loader from "../general_components/Loader";
	export default {
		name: "CloneCompanyFormModal",
		components: {Loader, Modal},
		props: {
			companies: {
				type: Array,
				default: () => { return []; }
			},
			load_url: {
				type: String,
				required: true
			},
			clone_url: {
				type: String,
				required: true,
			}
		},
		data(){
			return {
				loading: false,
				reload: false,
				cloning: false,

				selected_company: null,
				selected_form: null,

				forms: [],
			}
		},
		mounted() {
			document.getElementById('clone-form-button')
				.addEventListener('click', this.openModal);
		},
		methods: {
			openModal(){
				this.$nextTick(function (){
					this.$refs.modal.openModal();
				})
			},
			cancel(){
				this.$refs.modal.closeModal(null, true);
			},

			loadForms(){
				if (this.loading){
					this.reload = true;
					return;
				}

				this.selected_form = null;
				this.forms = [];
				this.loading = true;

				axios.get(this.load_url.replace('?', this.selected_company))
					.then(response => {
						this.loading = false;

						if (this.reload){
							this.reload = false;
							this.loadForms();
							return;
						}

						this.forms = response.data;
					})
			},

			clone(){
				if (this.loading) return;

				this.loading = true;
				this.cloning = true;

				axios.post(this.clone_url.replace('?', this.selected_form))
					.then(() => {
						window.location.reload();
					})
					.catch(() => {
						this.loading = false;
						this.cloning = false;
						this.reload = false;

                        Vue.$toast.open({
                            message: 'Something went wrong!',
                            type: 'error'
                        });
					})
			}
		},
		watch: {
			selected_company(){
				this.loadForms();
			}
		}
	}
</script>
